import * as Generated from './generated/AnalyticsBeacons'

// Alias the really long namespaces then re-export them in more consumable forms
// These are pretty common structs.
import ApplicationID = Generated.com.flipp.beacon.common.enumeration.ApplicationID
import Base = Generated.com.flipp.beacon.common.entity.Base
import Budget = Generated.com.flipp.beacon.common.entity.Budget
import Publisher = Generated.com.flipp.beacon.common.entity.Publisher
import Environment = Generated.com.flipp.beacon.hero.enumeration.Environment
import ClientParameters = Generated.undefined.ClientParameters
import LocationSource = Generated.com.flipp.beacon.hero.enumeration.LocationSource
import HeroCampaign = Generated.undefined.HeroCampaign
import HeroBase = Generated.com.flipp.beacon.hero.entity.HeroBase
import SchemaInfo = Generated.com.flipp.beacon.common.entity.SchemaInfo
import Flyer = Generated.com.flipp.beacon.common.entity.Flyer
import Merchant = Generated.com.flipp.beacon.common.entity.Merchant
import SourceAction = Generated.com.flipp.beacon.hero.enumeration.SourceAction
import ViewParameters = Generated.com.flipp.beacon.hero.entity.ViewParameters
import FlyerItem = Generated.com.flipp.beacon.common.entity.FlyerItem

// Beacons
import Beacon = Generated.com.flipp.beacon.hero.event.postExperience

enum Schemas {
    HeroPostOpenPostExperience = Generated.HeroPostOpenPostExperienceSchemaId,
    HeroPostOpenFlyer = Generated.HeroPostOpenFlyerSchemaId,
    HeroPostFlyerViewFlyer = Generated.HeroPostFlyerViewFlyerSchemaId,
    HeroPostFlyerEngagedVisitFlyer = Generated.HeroPostFlyerEngagedVisitFlyerSchemaId,
    HeroPostFlyerClickFlyerItem = Generated.HeroPostFlyerClickFlyerItemSchemaId,
    HeroPostClosePost = Generated.HeroPostClosePostSchemaId,
}

export {
    ApplicationID,
    Base,
    Budget,
    Publisher,
    Beacon,
    ClientParameters,
    LocationSource,
    Environment,
    Flyer,
    FlyerItem,
    HeroCampaign,
    HeroBase,
    SourceAction,
    ViewParameters,
    Merchant,
    Schemas,
    SchemaInfo,
}
